module.exports = __webpack_public_path__ + "img/arrow_pre.09e3b06d.svg";